export const userManagementT = {
  title: 'User management',
  table: {
    columns: {
      name: 'Name',
      email: 'E-mail',
      role: 'Role'
    }
  },
  actions: {
    addNewUser: 'Add new user'
  }
} as const;
